export enum OpenDialogState {
  details = 'details',
  remove = 'remove',
  duplicate = 'duplicate',
  none = 'none',
}
